import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate, useLocation } from "react-router-dom";
import { NAV_LINKS } from "../../data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const goTo = (href) => {
    if (location.pathname !== "/") navigate(`/${href}`);
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Enter your email");
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email });
      toast.success(data.status === "already_subscribed" ? "You're already subscribed" : "Subscribed to the dispatch");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email");
    } finally { setBusy(false); }
  };

  return (
    <footer data-testid="footer-section" className="bg-ink text-sand pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-sand/12">
          <div className="lg:col-span-5">
            <div className="font-display text-2xl tracking-[0.18em]">AURO<span className="text-gold">·</span>VENTURES</div>
            <p className="mt-5 max-w-sm text-sand/60 leading-relaxed font-quote italic text-lg">
              "Money is the visible sign of a universal force. In its true action it belongs to the Divine."
            </p>
            <p className="mt-2 text-sm text-brass">— Sri Aurobindo</p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.24em] text-brass font-semibold mb-5">Navigate</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.tid}><button onClick={() => goTo(l.href)} className="text-sand/70 hover:text-gold transition-colors">{l.label}</button></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.24em] text-brass font-semibold mb-5">The Dispatch</h4>
            <p className="text-sand/60 mb-4 text-sm">Occasional reflections on conscious capital & portfolio news.</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <input data-testid="footer-newsletter-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
                className="flex-1 rounded-full bg-white/[0.06] border border-sand/15 px-5 py-3 text-sand placeholder:text-sand/40 focus:outline-none focus:border-gold transition" />
              <button data-testid="footer-newsletter-btn" disabled={busy} className="rounded-full bg-gold text-ink font-medium px-5 py-3 hover:bg-brass transition-colors disabled:opacity-60">Join</button>
            </form>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-sand/45">
          <p>© {new Date().getFullYear()} Auro Ventures. In service of the conscious evolution of humanity.</p>
          <p className="tracking-wide">Truth · Harmony · Perfection</p>
        </div>
      </div>
    </footer>
  );
}
